import './ContentBuilderTemplate.scss';

import React from 'react';
import { forwardRefWithAs } from '../../../utils/types/PropsWithAsAttributes';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Article } from '../../Article/Article';
import { Button } from '@dataartdev/uikit/Button';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { PartnerCard } from '../../PartnerCard/PartnerCard';
import { IRoot16 } from './models/CTI_16.props';

export const ContentBuilderTemplate = forwardRefWithAs<IRoot16>(props => {
  const [isOpen, setIsOpen] = React.useState(false);

  const { type, title, text, partners = [], contentId } = usePropsHandler(
    cnContentBuilderTemplate(),
    props
  );

  const typeNumber = type.toString();

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      {title && (
        <Typography.Title
          className={cnContentBuilderTemplate('Title')}
          size="lg"
          as="h2"
        >
          {title}
        </Typography.Title>
      )}
      {text && (
        <Grid breakpoints={{ desktop: { cols: 12 } }}>
          <GridItem breakpoints={{ desktop: { col: 8 } }}>
            <Article
              content={text}
              className={cnContentBuilderTemplate('SubTitle')}
            />
          </GridItem>
        </Grid>
      )}
      {partners.length > 0 && (
        <Grid
          breakpoints={{
            desktop: { cols: 12, gap: 'xl' },
            tablet: { cols: 8, rowGap: 'xl', colGap: 'm' },
            mobile: { cols: 1, gap: 'xl' },
          }}
        >
          {partners.map((partner, index) => {
            if (!isOpen && index > 7) return false;
            return (
              <GridItem
                breakpoints={{
                  desktop: { col: 3 },
                  tablet: { col: 4 },
                  mobile: { col: 1 },
                }}
              >
                <PartnerCard {...partner} type={type} />
              </GridItem>
            );
          })}
        </Grid>
      )}
      {partners?.length > 8 && !isOpen && (
        <Button
          onClick={() => setIsOpen(true)}
          className={cnContentBuilderTemplate('MorePartners')}
          iconRight={IconArrowRight}
          view="secondary"
          label="View More"
        />
      )}
    </div>
  );
});

export default ContentBuilderTemplate;
